import './index.less'

import PropTypes from 'ant-design-vue/es/_util/vue-types'
import { isArray } from 'ant-design-vue/lib/_util/vue-types/utils'
import GridContent from '../GridContent'
import 'ant-design-vue/es/page-header/style'
import PageHeader, { PageHeaderProps } from 'ant-design-vue/es/page-header'
import 'ant-design-vue/es/tabs/style'
import Tabs from 'ant-design-vue/es/tabs'
import { getComponentFromProp } from 'ant-design-vue/lib/_util/props-util'
import i18n from '@/locales'

const prefixedClassName = 'ant-pro-page-header-wrap'

// 菜单名称国际化映射表
const getMenuLabelKey = (label) => {
  if (!label) return label
  
  const menuLabelMap = {
    '短剧管理': 'menu.videoManagement',
    '短剧列表': 'menu.videoList',
    '弹幕管理': 'menu.barrageManagement',
    '宣传片管理': 'menu.publicizeManagement',
    '敏感词管理': 'menu.sensitiveWordManagement',
    '短剧分类管理': 'menu.videoCategoryManagement',
    '用户购买剧集列表': 'menu.userBuyVideoList',
    '用户管理': 'menu.userManagement',
    '用户信息': 'menu.userInfo',
    '用户提现': 'menu.userWithdraw',
    '用户反馈': 'menu.userFeedback',
    '用户注销管理': 'menu.userCancelManagement',
    '用户报表': 'menu.userReport',
    '用户权益': 'menu.userRights',
    '兑换码': 'menu.exchangeCode',
    '拉人奖励配置': 'menu.referralRewardConfig',
    '会员购买列表': 'menu.vipPurchaseList',
    '签到配置': 'menu.signConfig',
    '任务奖励管理': 'menu.taskRewardManagement',
    '充值管理': 'menu.rechargeManagement',
    '充值菜单管理': 'menu.rechargeMenuManagement',
    '会员菜单管理': 'menu.vipMenuManagement',
    '资源位配置': 'menu.resourcePositionConfig',
    '网址管理': 'menu.urlManagement',
    '帮助中心': 'menu.helpCenter',
    '引导页': 'menu.guidePage',
    '分销配置': 'menu.distributionConfig',
    '轮播图管理': 'menu.carouselManagement',
    '搜索词管理': 'menu.searchWordManagement',
    '头像管理': 'menu.avatarManagement',
    'Tabbar管理': 'menu.tabbarManagement',
    '手机区号管理': 'menu.mobileCodeManagement',
    '财务报表': 'menu.financialReport',
    '短剧报表': 'menu.videoReport',
    '金币充值订单列表': 'menu.coinRechargeOrderList',
    '版本更新': 'menu.versionUpdate',
    '版本管理': 'menu.versionManagement',
    '系统管理': 'menu.systemManagement',
    '用户查询': 'menu.userQuery',
    '用户新增': 'menu.userAdd',
    '用户修改': 'menu.userEdit',
    '用户删除': 'menu.userDelete',
    '用户导出': 'menu.userExport',
    '用户导入': 'menu.userImport',
    '重置密码': 'menu.resetPassword',
    '角色管理': 'menu.roleManagement',
    '角色查询': 'menu.roleQuery',
    '角色新增': 'menu.roleAdd',
    '角色修改': 'menu.roleEdit',
    '角色删除': 'menu.roleDelete',
    '脱敏权限': 'menu.maskPermission',
    '菜单管理': 'menu.menuManagement',
    '菜单查询': 'menu.menuQuery',
    '菜单新增': 'menu.menuAdd',
    '菜单修改': 'menu.menuEdit',
    '菜单删除': 'menu.menuDelete',
    '参数设置': 'menu.paramSettings',
    '参数查询': 'menu.paramQuery',
    '参数新增': 'menu.paramAdd',
    '参数修改': 'menu.paramEdit',
    '参数删除': 'menu.paramDelete',
    '参数导出': 'menu.paramExport',
    '通知公告': 'menu.noticeAnnouncement',
    '公告查询': 'menu.noticeQuery',
    '公告新增': 'menu.noticeAdd',
    '公告修改': 'menu.noticeEdit',
    '公告删除': 'menu.noticeDelete',
    '日志管理': 'menu.logManagement',
    '操作日志': 'menu.operationLog',
    '操作查询': 'menu.operationQuery',
    '操作删除': 'menu.operationDelete',
    '日志导出': 'menu.logExport',
    '登录日志': 'menu.loginLog',
    '登录查询': 'menu.loginQuery',
    '登录删除': 'menu.loginDelete',
    '账户解锁': 'menu.accountUnlock',
    '系统工具': 'menu.systemTools',
    '表单构建': 'menu.formBuilder',
    '代码生成': 'menu.codeGeneration',
    '生成查询': 'menu.generateQuery',
    '生成修改': 'menu.generateEdit',
    '生成删除': 'menu.generateDelete',
    '导入代码': 'menu.importCode',
    '预览代码': 'menu.previewCode',
    '生成代码': 'menu.generateCode',
    '系统接口': 'menu.systemInterface',
    '数据库文档': 'menu.databaseDoc',
    '系统监控': 'menu.systemMonitor',
    '数据监控': 'menu.dataMonitor',
    '服务监控': 'menu.serviceMonitor',
    '缓存监控': 'menu.cacheMonitor',
    '缓存列表': 'menu.cacheList'
  }
  
  return menuLabelMap[label] || label
}

// 包装 i18nRender 函数，支持菜单国际化
const wrapI18nRender = (originalI18nRender) => {
  return (key) => {
    if (!key) return key
    
    // 如果 key 是国际化键值（以 route. 或 menu. 开头），直接使用原始 i18nRender
    if (typeof key === 'string' && (key.startsWith('route.') || key.startsWith('menu.'))) {
      return originalI18nRender ? originalI18nRender(key) : i18n.t(key)
    }
    
    // 如果 key 是菜单名称（在映射表中），先映射到国际化键值
    const i18nKey = getMenuLabelKey(key)
    if (i18nKey !== key) {
      // 映射到了国际化键值，使用 i18n 翻译
      return originalI18nRender ? originalI18nRender(i18nKey) : i18n.t(i18nKey)
    }
    
    // 否则直接使用原始 i18nRender 处理
    return originalI18nRender ? originalI18nRender(key) : key
  }
}

const PageHeaderTabConfig = {
  tabList: PropTypes.array,
  tabActiveKey: PropTypes.string,
  tabProps: PropTypes.object,
  tabChange: PropTypes.func
}

const PageHeaderWrapperProps = {
  ...PageHeaderTabConfig,
  ...PageHeaderProps,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  content: PropTypes.any,
  extraContent: PropTypes.any,
  pageHeaderRender: PropTypes.func,
  breadcrumb: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]).def(true),
  back: PropTypes.func,

  // only use `pro-layout` in children
  i18nRender: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]).def(false)
}

const defaultI18nRender = wrapI18nRender((t) => i18n.t(t))

const useContext = (route) => {
  return route && {
    ...route.meta
  } || null
}

const noop = () => {
}

// TODO :: tabList tab 支持图标 优化
const renderFooter = (h, tabConfigProps, i18nRender) => {
  const {
    tabList,
    tabActiveKey,
    tabChange: onTabChange,
    tabBarExtraContent,
    tabProps
  } = tabConfigProps
  return tabList && tabList.length > 0 && (
    <Tabs
      class={`${prefixedClassName}-tabs`}
      activeKey={tabActiveKey}
      onChange={key => {
        if (onTabChange) {
          onTabChange(key)
        }
      }}
      tabBarExtraContent={tabBarExtraContent}
      {...tabProps}
    >
      {tabList.map(item => (
        <Tabs.TabPane {...item} tab={i18nRender(item.tab)} key={item.key}/>
      ))}
    </Tabs>
  )
}

const renderPageHeader = (h, content, extraContent) => {
  if (!content && !extraContent) {
    return null
  }
  return (
    <div class={`${prefixedClassName}-detail`}>
      <div class={`${prefixedClassName}-main`}>
        <div class={`${prefixedClassName}-row`}>
          {content && (
            <div class={`${prefixedClassName}-content`}>{content}</div>
          )}
          {extraContent && (
            <div class={`${prefixedClassName}-extraContent`}>
              {extraContent}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

const defaultPageHeaderRender = (h, props, pageMeta, i18nRender) => {
  const {
    title: propTitle,
    tags,
    content,
    pageHeaderRender,
    extra,
    extraContent,
    breadcrumb,
    back: handleBack,
    ...restProps
  } = props
  if (pageHeaderRender) {
    return pageHeaderRender({ ...props })
  }
  let pageHeaderTitle = propTitle
  if (!propTitle && propTitle !== false) {
    // pageHeaderTitle = pageMeta.title
    // 2021.02.03 去除title显示
    pageHeaderTitle = undefined
  }
  // title props 不是 false 且不是 array 则直接渲染 title
  // 反之认为是 VNode, 作为 render 参数直接传入到 PageHeader
  const title = isArray(pageHeaderTitle)
    ? pageHeaderTitle
    : pageHeaderTitle && i18nRender(pageHeaderTitle)
  const tabProps = {
    breadcrumb,
    extra,
    tags,
    title,
    footer: renderFooter(h, restProps, i18nRender)
  }
  if (!handleBack) {
    tabProps.backIcon = false
  }

  return (
    <PageHeader {...{ props: tabProps }} onBack={handleBack || noop}>
      {renderPageHeader(h, content, extraContent)}
    </PageHeader>
  )
  // return
}

const PageHeaderWrapper = {
  name: 'PageHeaderWrapper',
  props: PageHeaderWrapperProps,
  inject: ['locale', 'contentWidth', 'breadcrumbRender'],
  render (h) {
    const { $route, $listeners } = this
    const children = this.$slots.default
    const title = getComponentFromProp(this, 'title')
    const tags = getComponentFromProp(this, 'tags')
    const content = getComponentFromProp(this, 'content')
    const extra = getComponentFromProp(this, 'extra')
    const extraContent = getComponentFromProp(this, 'extraContent')

    const pageMeta = useContext(this.$props.route || $route)
    const originalI18nRender = this.$props.i18nRender || this.locale
    const i18nRenderFunc = originalI18nRender ? wrapI18nRender(originalI18nRender) : defaultI18nRender
    const contentWidth = this.$props.contentWidth || this.contentWidth || false
    // 当未设置 back props 或未监听 @back，不显示 back
    // props 的 back 事件优先级高于 @back，需要注意
    const onBack = this.$props.back || $listeners.back
    const back = onBack && (() => {
      // this.$emit('back')
      // call props back func
      onBack && onBack()
    }) || undefined

    const onTabChange = this.$props.tabChange
    const tabChange = (key) => {
      this.$emit('tabChange', key)
      onTabChange && onTabChange(key)
    }

    let breadcrumb = {}
    const propsBreadcrumb = this.$props.breadcrumb
    if (propsBreadcrumb === true) {
      let routes = $route.matched.concat().filter(route => route && route.meta && route.meta.title)
      routes = routes.map(route => {
        if (route && route.meta && route.meta.title) {
          return {
            path: route.path,
            breadcrumbName: i18nRenderFunc(route.meta.title),
            redirect: route.redirect
          }
        }
      })
      const defaultItemRender = ({ route, params, routes, paths, h }) => {
        return (route.redirect === 'noRedirect' || routes.indexOf(route) === routes.length - 1) && (
          <span>{route.breadcrumbName}</span>
        ) || (
          <router-link to={{ path: route.path || '/', params }}>{route.breadcrumbName}</router-link>
        )
      }

      // If custom breadcrumb render undefined
      // use default breadcrumb..
      const itemRender = this.breadcrumbRender || defaultItemRender

      breadcrumb = { props: { routes, itemRender } }
    } else {
      breadcrumb = propsBreadcrumb || null
    }

    const props = {
      ...this.$props,
      title,
      tags,
      content,
      extra,
      extraContent,
      breadcrumb,
      tabChange,
      back
    }

    return (
      <div class="ant-pro-page-header-wrap">
        <div class={`${prefixedClassName}-page-header-warp`}>
          <GridContent>{defaultPageHeaderRender(h, props, pageMeta, i18nRenderFunc)}</GridContent>
        </div>
        {children ? (
          <GridContent contentWidth={contentWidth}>
            <div class={`${prefixedClassName}-children-content`}>
              {children}
            </div>
          </GridContent>
        ) : null}
      </div>
    )
  }
}

PageHeaderWrapper.install = function (Vue) {
  Vue.component(PageHeaderWrapper.name, PageHeaderWrapper)
  Vue.component('page-container', PageHeaderWrapper)
}

export default PageHeaderWrapper
